import { workflowInstance_V2 } from "../../services/api";
import { callApi } from "../../services/generic";
import { CreateSupportRequestResponse } from "../../types";
import { SUPPORT_ENDPOINTS } from ".";

export const postNewSupportRequest = async (
  formData: FormData,
): Promise<CreateSupportRequestResponse> =>
  callApi(() =>
    workflowInstance_V2.post(SUPPORT_ENDPOINTS.SUPPORT, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    }),
  );
